import { render } from "./ViewArticle.vue?vue&type=template&id=22541cc0&ts=true"
import script from "./ViewArticle.vue?vue&type=script&lang=ts"
export * from "./ViewArticle.vue?vue&type=script&lang=ts"

import "./ViewArticle.vue?vue&type=style&index=0&id=22541cc0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__